import React from 'react';
import {
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
  EditButton,
  DeleteButton,
  ListButton,
} from 'react-admin';
import { Grid, Typography, Box } from '@mui/material';
import { Security } from '@mui/icons-material';
import { RolePermissionsManager } from './components/RolePermissionsManager';
import DeleteWithPasswordButton from '@/components/DeleteWithPasswordButton';

const RoleShowActions = () => (
  <TopToolbar>
    <EditButton />
    <DeleteWithPasswordButton resource='roles' label='Eliminar' />
    <ListButton />
  </TopToolbar>
);

export const RolesShow: React.FC = () => (
  <Show title='Detalles del Rol' actions={<RoleShowActions />}>
    <SimpleShowLayout>
      <Box sx={{ width: '100%' }}>
        {/* Header con icono */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 3,
            p: 2,
            borderRadius: 1,
          }}
        >
          <Security sx={{ fontSize: 48, mr: 2, color: 'primary.main' }} />
          <Box>
            <Typography variant='h5'>
              <TextField source='name' />
            </Typography>
            <Typography variant='subtitle1' color='textSecondary'>
              Rol del Sistema
            </Typography>
          </Box>
        </Box>

        <Typography variant='h6' gutterBottom>
          Información General
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField source='id' label='ID del Rol' />
          </Grid>

          <Grid item xs={12}>
            <TextField source='roles' label='Nombre del Rol' />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <TextField source='name' label='Nombre del Rol' />
        </Grid>
      </Box>
      <RolePermissionsManager />
    </SimpleShowLayout>
  </Show>
);
